<div id="main">

  <div class="modal-header">
    <h4 class="modal-title">{{projectName}} - {{"SFTP_EXPORT" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" id="close" mat-dialog-close>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body formModal">
    <app-progressbar *ngIf="showSpinner"></app-progressbar>
    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step [stepControl]="csvSubscriptionForm">
        <form [formGroup]="csvSubscriptionForm">
          <ng-template matStepLabel>{{'INFORMATION' | translate}}</ng-template>
          <mat-slide-toggle
            [(ngModel)]="staticSubscription"
            [ngModelOptions]="{standalone: true}">
            {{'STATIC_SUBSCRIPTION' | translate}}
          </mat-slide-toggle>
          <mat-slide-toggle
            [(ngModel)]="dynamicSubscription"
            [ngModelOptions]="{standalone: true}">
            {{'DYN_SUBSCRIPTION' | translate}}
          </mat-slide-toggle>
          <mat-slide-toggle
            [(ngModel)]="realTimeSubscription"
            [ngModelOptions]="{standalone: true}">
            {{'RT_SUBSCRIPTION' | translate}}
          </mat-slide-toggle>
          <br/>
          <mat-form-field>
            <input matInput [placeholder]="('ftp_Server' | translate)" formControlName="ftpServer"
                   autocomplete="new-password">
          </mat-form-field>
          <mat-form-field>
            <input matInput [placeholder]="('ftp_Port' | translate)" formControlName="ftpPort"
                   autocomplete="new-password" type="number">
          </mat-form-field>
          <mat-form-field>
            <input matInput [placeholder]="('ftp_User' | translate)" formControlName="ftpUser"
                   autocomplete="new-password">
          </mat-form-field>
          <mat-form-field>
            <input matInput [placeholder]="('ftp_Password' | translate)" formControlName="ftpPassword" type="password"
                   autocomplete="new-password">
          </mat-form-field>
          <mat-slide-toggle formControlName="deleteDataAfterExport"
                            [(ngModel)]="csvSubscriptionForm.value.deleteDataAfterExport">
            {{getDeleteDataAfterExportText()}}
          </mat-slide-toggle>
          <br/>
          <div>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
              Next
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{'CHECK_SAVE' | translate}}</ng-template>
        <div *ngIf="csvSubscriptionForm">
          <div><b [innerHtml]="'INFORMATION' | translate"></b></div>
          <mat-slide-toggle
            [(ngModel)]="staticSubscription" [disabled]="true">
            {{'STATIC_SUBSCRIPTION' | translate}}
          </mat-slide-toggle>
          <mat-slide-toggle
            [(ngModel)]="dynamicSubscription" [disabled]="true">
            {{'DYN_SUBSCRIPTION' | translate}}
          </mat-slide-toggle>
          <mat-slide-toggle
            [(ngModel)]="realTimeSubscription" [disabled]="true">
            {{'RT_SUBSCRIPTION' | translate}}
          </mat-slide-toggle>
          <br/>
          <mat-form-field class="readonly">
            <input matInput [placeholder]="('ftp_Server' | translate)"
                   [value]="csvSubscriptionForm.value.ftpServer"
                   [readonly]="true">
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput [placeholder]="('ftp_Port' | translate)"
                   [value]="csvSubscriptionForm.value.ftpPort"
                   [readonly]="true">
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput [placeholder]="('ftp_User' | translate)"
                   [value]="csvSubscriptionForm.value.ftpUser"
                   [readonly]="true">
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput [placeholder]="('ftp_Password' | translate)" type="password"
                   [value]="csvSubscriptionForm.value.ftpPassword"
                   [readonly]="true">
          </mat-form-field>
          <mat-slide-toggle [disabled]="true"
                            [(ngModel)]="csvSubscriptionForm.value.deleteDataAfterExport">
            {{getDeleteDataAfterExportText()}}
          </mat-slide-toggle>
          <br/>
          <div>
            <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
              Back
            </button>
            <button type="button" class="btn btn-warning" (click)="postCsvSubscription()">
              <app-progressbar *ngIf="showSpinner"></app-progressbar>
              {{'SAVE'|translate}}
            </button>
          </div>

        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
